import { Link } from 'react-router-dom'
import moment from 'moment'
import { PencilIcon } from '@heroicons/react/20/solid'
import { useTranslation } from 'react-i18next'

const currencyFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'PLN',
	maximumFractionDigits: 2,
})

const formatAmount = value => {
	if (typeof value !== 'number') return '—'
	return currencyFormatter.format(value)
}

const formatDate = value => {
	if (!value) return '—'
	return moment(value).isValid() ? moment(value).format('YYYY-MM-DD') : '—'
}

const CheckCell = ({ checked }) => (
	<span className="inline-flex items-center justify-center w-10">
		{checked ? <span className="text-blue-600 text-lg">✓</span> : <span className="text-gray-400">—</span>}
	</span>
)

export default function ExpensesTableRow({ expense, isSelected, onSelectExpense }) {
	const { t } = useTranslation()
	const tags = Array.isArray(expense.tags) ? expense.tags : []

	return (
		<tr className="hover:bg-gray-100">
			<td className="py-2 px-4 border-b border-gray-300 text-left w-12">
				<input
					type="checkbox"
					checked={isSelected}
					onChange={e => onSelectExpense(expense._id, e.target.checked)}
					className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
				/>
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<Link
					to={`/ksiegowosc/expenses/details/${expense._id}`}
					className="font-medium text-blue-600 hover:text-blue-800 hover:underline transition-colors duration-200"
				>
					{expense.expenseName || t('expenses.list.table.untitled')}
				</Link>
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<span className="font-semibold text-green-600">{formatAmount(expense.expenseTotal ?? expense.expenseSubtotal)}</span>
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<CheckCell checked={!!expense.forVat} />
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<CheckCell checked={!!expense.forCorporateTax} />
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<div className="flex flex-wrap gap-1">
					{tags.length
						? tags.slice(0, 3).map((tag, index) => (
							<span
								key={`${expense._id}-${tag}-${index}`}
								className="px-2 py-0.5 text-xs rounded-full bg-slate-100 text-slate-700 border border-slate-200"
							>
								{tag}
							</span>
						))
						: <span className="text-xs text-gray-400">{t('expenses.list.table.noTags')}</span>}
				</div>
			</td>
			<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap">
				<span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-200 text-black">
					{formatDate(expense.expenseDate)}
				</span>
			</td>
				<td className="py-2 px-4 border-b border-gray-300 whitespace-nowrap text-right">
					<Link
						to={`/ksiegowosc/expenses/edit/${expense._id}`}
						className="inline-flex items-center gap-1 rounded-md border border-blue-100 bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-700 hover:bg-blue-100 focus:outline-none focus:ring-2 focus:ring-blue-200"
					>
						<PencilIcon className="h-4 w-4" />
						<span>{t('expenses.list.table.edit')}</span>
					</Link>
				</td>
		</tr>
	)
}
